module.exports = __webpack_public_path__ + "4914b40504850ce7fa40aa544f981d3e.svg";